var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticStyle: { height: "30px", "border-bottom": "1px solid #ddd" } },
        [_c("el-col", { attrs: { span: 24 } }, [_vm._v(" 选择商品 ")])],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          staticClass: "demo-form-inline",
          staticStyle: { "margin-top": "20px" },
          attrs: { inline: true }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "买手组" } },
            [
              _c("el-input", {
                staticStyle: { width: "300px", "margin-left": "-10px" },
                attrs: { size: "small", placeholder: "请输入买手组" },
                model: {
                  value: _vm.form.picker,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "picker", $$v)
                  },
                  expression: "form.picker"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "150px" },
                  attrs: { size: "small", placeholder: "商品名称" },
                  model: {
                    value: _vm.searchType,
                    callback: function($$v) {
                      _vm.searchType = $$v
                    },
                    expression: "searchType"
                  }
                },
                [
                  _c("el-option", {
                    attrs: { label: "商品名称", value: "goods_name" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { label: "商品货号", value: "goods_no" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { label: "商品款号", value: "goods_kh" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c("el-input", {
                staticStyle: { width: "300px", "margin-left": "-10px" },
                attrs: { size: "small", placeholder: "请输入" },
                model: {
                  value: _vm.searchName,
                  callback: function($$v) {
                    _vm.searchName = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "searchName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "-10px" },
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.search()
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading"
                }
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.goodsData, height: "600" },
              on: { "selection-change": _vm.handleSelectionChange }
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "goods_kh", label: "款号", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "goods_name",
                  label: "商品标题",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "goods_no", label: "商品货号", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "pg_name", label: "买手组", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "goods_img", label: "图片", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", [
                          _c("img", {
                            staticStyle: { width: "50px", height: "50px" },
                            attrs: { src: scope.row.goods_img },
                            on: {
                              click: function($event) {
                                return _vm.previewImage(scope.row.goods_img)
                              }
                            }
                          })
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "market_price",
                  label: "代采价",
                  align: "center"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.allData
        ? _c(
            "div",
            { staticStyle: { "text-align": "right", padding: "25px" } },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.curPage,
                  background: "",
                  layout: "total, prev, pager, next, jumper ",
                  total: _vm.allData.total,
                  "page-size": 10
                },
                on: {
                  "update:currentPage": function($event) {
                    _vm.curPage = $event
                  },
                  "update:current-page": function($event) {
                    _vm.curPage = $event
                  },
                  "current-change": _vm.handleCurrentChange
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticStyle: { width: "80%", height: "auto" },
          attrs: { visible: _vm.dialogVisible, "append-to-body": "" },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" }
          })
        ]
      ),
      _vm._v(" "),
      _c("el-row", { staticStyle: { width: "100%" } }, [
        _c(
          "div",
          { staticStyle: { "line-height": "30px", display: "flex" } },
          [
            _c(
              "el-button",
              {
                staticStyle: {
                  "margin-left": "80%",
                  height: "40px",
                  width: "80px",
                  "font-size": "16px"
                },
                attrs: { size: "small", type: "info" },
                on: { click: _vm.closePage }
              },
              [_vm._v("取消")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticStyle: {
                  height: "40px",
                  width: "80px",
                  "font-size": "16px"
                },
                attrs: { size: "small", type: "warning" },
                on: { click: _vm.addSpuGoods }
              },
              [_vm._v("确认")]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-519a9284", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-519a9284","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SelectGoodsList.vue
// module id = null
// module chunks = 